export const GEOPOSITION_ERRORS = {
    'error': 'Ошибка приложения',
    1: 'Проверьте, разрешен ли доступ к вашему местоположению на вашем устройстве или браузере',
    2: 'Получение местоположения не доступно',
    3: 'Истекло время получения местоположения'
};

export const MAX_DISTANCE = 500;
